import { cn } from "@/lib/utils";
import { trackEvent, ANALYTICS_EVENTS } from '@/lib/analytics';

interface SecondaryNavItem {
  label: string;
  anchor: string;
}

interface SecondaryNavProps {
  items: SecondaryNavItem[];
  visible?: boolean;
}

export default function SecondaryNav({ items, visible = true }: SecondaryNavProps) {
  const handleClick = (anchor: string, label: string) => {
    // ⚠️ ANALYTICS: Track secondary nav click
    trackEvent(ANALYTICS_EVENTS.NAV_ITEM_CLICKED, {
      nav_type: 'secondary',
      nav_item_label: label,
      nav_item_anchor: anchor,
      nav_page: window.location.pathname,
      scroll_target: `#${anchor}`,
    });

    const element = document.getElementById(anchor);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex items-center gap-8">
      {items.map((item) => (
        <button
          key={item.anchor}
          onClick={() => handleClick(item.anchor, item.label)}
          className={cn(
            "text-xs transition-colors duration-300 hover:opacity-70",
            visible ? "text-foreground" : "text-white",
            "font-normal"
          )}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
